<template>
  <v-app :class="{ 'no-overflow': removeOverflow }">
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",
  created() {
    if (!this.isMobile) {
      this.$store.commit("setMainMenu", true);
    }
  },
  computed: {
    removeOverflow() {
      return (
        this.$route.name === "tenant.dashboard" ||
        this.$route.name === "tenants"
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue